import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { LOCALE_CODES } from '@VineyardLibConstant/constant';

@Injectable({
  providedIn: 'root',
})
export class ClientSettingService {
  private translateService = inject(TranslateService);

  private currentLocale = LOCALE_CODES.EN;
  get locale(): string {
    return this.currentLocale;
  }

  initializeAppLang(): void {
    this.setCurrentLocale();
    this.translateService.setFallbackLang(LOCALE_CODES.EN);
    this.translateService.use(this.locale);
  }

  private setCurrentLocale(): void {
    const browserLang = this.translateService.getBrowserLang();
    if (browserLang !== LOCALE_CODES.FR && browserLang !== LOCALE_CODES.JA) {
      this.currentLocale = LOCALE_CODES.EN;
      return;
    }
    this.currentLocale = browserLang;
  }
}
